import React from 'react'
import { useTaskStoreManager } from 'context/HomeStore/Manager/TaskProvider/TaskProvider.manager'
import Filter from 'pages/Mobile/Home/Manager/components/Tasks/Filter/Filter'
import { Grid } from '@material-ui/core'
import TaskSwitcher from 'components/Mobile/Tasks/TaskSwitcher'
import TaskCard from 'components/Mobile/Tasks/TaskCard'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { Pagination } from 'asterX-UI/Pagination'

const TasksTab = () => {
  const { taskStore, taskStoreFunc } = useTaskStoreManager()
  const onPaginationChange = (e, page) => {
    page = page === 0 ? page : page - 1
    taskStoreFunc.onPaginationChange(page)
  }

  return (
    <Grid container spacing={2}>
      <LoaderBackdrop loading={taskStore.loading} />

      <Grid item xs={12} md={12}>
        <Filter />
      </Grid>

      <Grid item xs={12} md={12}>
        <TaskSwitcher
          isClosedTasks={taskStore.isClosedTasks}
          onChange={taskStoreFunc.onSetIsClosedTasks}
          taskCounts={taskStore.taskCounts}
        />
      </Grid>

      <Grid item xs={12} md={12}>
        {taskStore.list?.length > 0
          ? taskStore.list.map((task, index) => (
              <TaskCard
                task={task}
                key={`task_${index}`}
                isClosedTasks={taskStore.isClosedTasks}
                reload={taskStoreFunc.reload}
              />
            ))
          : 'Нет данных'}
      </Grid>

      <Grid item xs={12} md={12}>
        <Pagination
          count={taskStore?.pagination?.pageCount}
          page={taskStore?.pagination?.page + 1}
          onChange={onPaginationChange}
          isMobile
        />
      </Grid>
    </Grid>
  )
}

export default TasksTab
